export type DialogState = {
  dialogVisible: boolean
  dialogTitle: string
  dialogComponent: string | Object | Function
  dialogPayload: any
  dialogWidth: string
}

export const dialogState: DialogState = {
  dialogVisible: false,
  dialogTitle: '',
  dialogComponent: '',
  dialogPayload: null,
  dialogWidth: '',
}
